import React, { Component } from 'react';
import './BottomBreadcrumb.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { string } from '../../../localization/Localization';
import { Tooltip } from 'reactstrap';
import { COLORS } from '../../../utilities/theme/colors';
import * as pageControllerActions from '../../../redux/pageControllerActions';
import * as homeActions from '../../../redux/homeActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as vanillaDesignActions from '../../../redux/vanillaDesignActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as Constants from '../../../utilities/constants/Constants';
import * as gaHelpers from '../../../utilities/GAHelpers/GAHelpers';
import {
  hasRip,
  isProjectDirty,
  isSignageSuiteProduct,
  isModelPage,
  isEditLink
} from '../../../utilities/HelperFunctions/HelperFunctions';
import RipChangeModal from '../../../components/RipChangeModal/RipChangeModal';

class BottomBreadcrumb extends Component {
  state = {
    stepTooltipOpen: false,
    stepTitle: string.MODEL_TITLE_KEY,
    stepId: 'two',
    disableClickForNextButton: false
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleEnterKey);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEnterKey);
  }

  handleEnterKey = event => {
    const { currentPageIndex, isPresetSizePage } = this.props;
    if (
      event.keyCode === 13 &&
      !this.disableNextForCustom() &&
      isModelPage(currentPageIndex) &&
      isPresetSizePage &&
      !isSignageSuiteProduct()
    ) {
      this.goToNextPage();
    }
  };

  setBottomBreadcrumbsBackgroundColor = () => {
    const { envData, commonSetting } = this.props;
    const enterpriseAccount = envData ? envData.enterprise_account : null;

    let bottombarColor = null;
    if (commonSetting && !commonSetting.useDefaultColors) {
      bottombarColor = `#${commonSetting.bottomBarColor}`;
    }
    if (enterpriseAccount && bottombarColor) {
      return bottombarColor;
    }
    if (isSignageSuiteProduct()) {
      return COLORS.bgPrimary;
    }
    return COLORS.bgWhite;
  };

  breadcrumbsButtonHandler = item => {
    const {
      currentPageIndex,
      isSingleProduct,
      bottomBarStatus,
      dispatchers
    } = this.props;
    const breadcrumbsButtonClassName = [bottomBarStatus[item.id]];
    if (item.name === string.MODEL_TITLE_KEY) {
      const { multiWallProjects } = this.props;
      if (
        isModelPage(currentPageIndex) ||
        (isSingleProduct && isSignageSuiteProduct()) ||
        (isEditLink() && multiWallProjects.length > 1)
      ) {
        breadcrumbsButtonClassName.push('pointer-event-null');
      }
    } else if (item.name === string.DESIGN_KEY) {
      if (currentPageIndex === Constants.DESIGN_PAGE) {
        breadcrumbsButtonClassName.push('pointer-event-null');
      }
    } else if (item.name === string.FINAL_CHECK_TITLE_KEY) {
      if (
        currentPageIndex === Constants.FINAL_CHECK_KEY ||
        (currentPageIndex === Constants.DESIGN_PAGE &&
          dispatchers.pageControllerActions.doesProjectHasNoContents())
      ) {
        breadcrumbsButtonClassName.push('pointer-event-null');
      }
    }
    return breadcrumbsButtonClassName.join(' ');
  };

  goToNextPage = () => {
    const { disableClickForNextButton } = this.state;
    if (!disableClickForNextButton) {
      this.setState({ disableClickForNextButton: true });
      const { currentPageIndex, isPresetSizePage, dispatchers } = this.props;
      if (!dispatchers.pageControllerActions.shouldDisableNextButton()) {
        if (
          currentPageIndex === Constants.SIZE_SELECTION_PAGE &&
          !isPresetSizePage
        ) {
          dispatchers.homeActions.settingsWallChange('custom');
        } else {
          dispatchers.pageControllerActions.goToNextPage();
        }
        this.setState({ disableClickForNextButton: false });
      }
    }
  };

  disableNextForCustom = () => {
    const { isPresetSizePage, dispatchers, variableSizeType } = this.props;
    // If it is Model selection page not custom one
    if (isPresetSizePage) {
      if (
        dispatchers.homeActions.isPresetSizeAvailableInLaunch(variableSizeType)
      ) {
        return false;
      }
    }
    return true;
  };

  disableSaveButton = () => {
    const { fabricCanvasReducer } = this.props;
    if (!isProjectDirty(fabricCanvasReducer)) {
      return true;
    }
    return false;
  };

  styleForSaveButtton = () => {
    if (this.disableSaveButton()) {
      return 'bottombar-save bottombar-next-disable';
    }
    return 'bottombar-save bottombar-save-enable';
  };

  styleForNextButton = () => {
    const { dispatchers } = this.props;
    if (dispatchers.pageControllerActions.shouldDisableNextButton()) {
      return 'bottombar-next bottombar-next-disable';
    }
    return 'bottombar-next bottombar-next-enable';
  };

  saveIsClicked = () => {
    const { dispatchers } = this.props;
    dispatchers.gaHelpers.saveGAEvent(
      Constants.GA_EVENT_ACTIONS.SAVE_JOB_PROJECT
    );
    dispatchers.fabricCanvasActions.saveIsClicked();
  };

  mouseEnterStepButton = (title, index) => {
    this.setState({
      stepTooltipOpen: true,
      stepTitle: title,
      stepId: index
    });
  };

  mouseLeaveStepButton = () => {
    this.setState({
      stepTooltipOpen: false
    });
  };

  canShowLiteVersionSaveButton = () => {
    const { currentPageIndex, isVanilla } = this.props;
    return (
      currentPageIndex != Constants.FILE_PROCESSING_PAGE &&
      currentPageIndex != Constants.DESIGN_SHARE_PAGE &&
      isVanilla
    );
  };

  render() {
    const {
      envData,
      dispatchers,
      currentPageIndex,
      pages,
      isLitePatner,
      isVanilla,
      viewOnlyPreviewMode,
      customClass,
      handleBottomBreadcrumbClick,
      wallCanvas,
      storeId
    } = this.props;
    const { stepTooltipOpen, stepId, stepTitle } = this.state;

    let disableModalBreadcrumb = false;
    if (
      envData &&
      envData.wallart_lite_web_link &&
      envData.product_width !== '' &&
      envData.product_height !== ''
    ) {
      disableModalBreadcrumb = true;
    }

    const breadcrumbs = [
      {
        id: 1,
        name: string.MODEL_TITLE_KEY,
        numberClass: 'one',
        link: () =>
          disableModalBreadcrumb
            ? false
            : dispatchers.homeActions.modelIsSelected()
      },
      {
        id: 2,
        name: string.DESIGN_KEY,
        numberClass: 'two',
        link: () =>
          !isModelPage(currentPageIndex) &&
          currentPageIndex !== Constants.DESIGN_PAGE
            ? dispatchers.pageControllerActions.setCurrentPageIndex(
                Constants.DESIGN_PAGE
              )
            : false
      },
      {
        id: 3,
        name: string.FINAL_CHECK_TITLE_KEY,
        numberClass: 'three',
        link: () => {
          if (
            currentPageIndex === Constants.DESIGN_PAGE &&
            wallCanvas.getObjects().length > 0
          ) {
            dispatchers.pageControllerActions.goToNextPage();
          }
        }
      }
    ];

    const nextButtonTitle =
      pages[currentPageIndex] && pages[currentPageIndex].nextBtnTitle
        ? pages[currentPageIndex].nextBtnTitle
        : null;

    const bottomBarStyle =
      isVanilla &&
      (currentPageIndex === Constants.INITIAL_PRINT_PAGE ||
        currentPageIndex === Constants.FINAL_CHECK_PAGE ||
        currentPageIndex === Constants.PRINT_PAGE)
        ? 'bottombar-wrapper-vanilla'
        : null;

    const bottombarClass = `${customClass} ${handleBottomBreadcrumbClick}`;
    const wrapperClassName = `bottombar-wrapper ${bottomBarStyle}`;
    let nonVanillaClassName =
      'd-flex align-items-center clearfix justify-content-center ';
    if (currentPageIndex != Constants.FINAL_CHECK_PAGE) {
      nonVanillaClassName += 'bottom-alignment';
    }
    return (
      <div className={bottombarClass}>
        <div
          className={wrapperClassName}
          style={{
            backgroundColor: this.setBottomBreadcrumbsBackgroundColor()
          }}
        >
          {!viewOnlyPreviewMode ? (
            <div>
              {' '}
              {dispatchers.pageControllerActions.canShowNextButton() ? (
                <div
                  role='button'
                  tabIndex='0'
                  className={this.styleForNextButton()}
                  id='help-next'
                  onKeyPress={() => {}}
                  onClick={this.goToNextPage}
                >
                  {nextButtonTitle}
                </div>
              ) : null}
              {!isVanilla ? (
                <div
                  className={nonVanillaClassName}
                  style={{
                    paddingRight:
                      currentPageIndex != Constants.DESIGN_PAGE ||
                      dispatchers.sideBarActions.shouldHideSidebarInDesktopMode()
                        ? null
                        : '392px'
                  }}
                  id='bottombar'
                >
                  {breadcrumbs.map(item => (
                    <div
                      role='button'
                      tabIndex='0'
                      id={`tooltip-${item.numberClass}`}
                      key={item.id}
                      style={{ outline: 'none' }}
                      className={this.breadcrumbsButtonHandler(item)}
                      onClick={item.link}
                      onKeyPress={() => {}}
                      onMouseEnter={() =>
                        this.mouseEnterStepButton(item.name, item.numberClass)
                      }
                      onMouseLeave={() => this.mouseLeaveStepButton()}
                    >
                      <span className={item.numberClass}>{item.id}</span>{' '}
                      {item.name}
                    </div>
                  ))}
                  {window.innerWidth < 976 && !isModelPage(currentPageIndex) ? (
                    <Tooltip
                      id='tooltip-inner'
                      placement='top'
                      isOpen={stepTooltipOpen}
                      target={`tooltip-${stepId}`}
                    >
                      {stepTitle}
                    </Tooltip>
                  ) : null}
                </div>
              ) : (
                <div>
                  {isLitePatner && this.canShowLiteVersionSaveButton() ? (
                    <div
                      role='button'
                      tabIndex='0'
                      onClick={this.saveIsClicked}
                      onKeyPress={() => {}}
                      // className="bottombar-save"
                      className={this.styleForSaveButtton()}
                      id='save'
                    >
                      <text className='next-label'>{string.SAVE_KEY}</text>
                    </div>
                  ) : null}

                  {currentPageIndex === Constants.FINAL_CHECK_PAGE &&
                  hasRip(storeId) !== null ? (
                    <div className='printerDetails'>
                      <img
                        className='icon'
                        alt='RIP'
                        src={Constants.RIP_LIST[hasRip(storeId)].img}
                      />
                      <span>
                        <span>
                          {string.formatString(
                            string.DEFAULT_PRINTING_OPTION_KEY,
                            Constants.RIP_LIST[hasRip(storeId)].name
                          )}
                        </span>
                        <span
                          role='button'
                          tabIndex='0'
                          onKeyPress={() => {}}
                          onClick={() =>
                            dispatchers.pageControllerActions.setCurrentPageIndex(
                              Constants.PRINT_PAGE
                            )
                          }
                        >
                          <span className='change'>
                            {string.LINKLABEL_TITLE_KEY}
                          </span>
                          <span>{Constants.NEXT_STEP_ARROW}</span>
                        </span>
                      </span>
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          ) : null}
        </div>

        <RipChangeModal />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bottomBarStatus: state.fabricCanvas.bottomBarStatus,
    language: state.home.language,
    isVanilla: state.modal.envData.is_vanilla_designer,
    isLitePatner: state.modal.envData.is_lite_patner,
    currentPageIndex: state.pageController.currentPageIndex,
    storeId: state.modal.storeData.id,
    pages: state.pageController.pages,
    commonSetting: state.modal.storeData.commonSetting,
    viewOnlyPreviewMode: state.modal.envData.view_only_preview_mode,
    isPresetSizePage: state.pageController.isPresetSizePage,
    wallCanvas: state.fabricCanvas.wallCanvas,
    loggedInToPattren: state.modal.envData.has_valid_pattern_design_account,
    loggedInToVecteezy: state.modal.envData.has_valid_vecteezy_account,
    loggedInToAdobeStock: state.modal.envData.has_valid_adobe_stock_account,
    loggedInToDreamstime: state.modal.envData.has_valid_dreamstime_account,
    fabricCanvasReducer: state.fabricCanvas,
    triggerProjectDirty: state.fabricCanvas.triggerProjectDirty,
    makeProjectDirtyWithNoUndoSupport:
      state.fabricCanvas.makeProjectDirtyWithNoUndoSupport,
    envData: state.modal.envData,
    handleBottomBreadcrumbClick: state.sideBar.handleBottomBreadcrumbClick,
    defaultProductSizes: state.modal.productSizes.default,
    variableSizeType: state.modal.storeData.variableSizeType,
    allowCustomSizeInPreset: state.modal.storeData.allowCustomSizeInPreset,
    category: state.modal.envData.category,
    sessionData: state.modal.sessionData,
    isSingleProduct: state.modal.isSingleProduct,
    project: state.finalCheck.project,
    multiCanvasPopoverStatus: state.home.multiCanvasPopoverStatus,
    multiWallProjects: state.finalCheck.multiWallProjects,
    canvasType: state.home.canvasType,
    customWall: state.home.customWall,
    canvasWall: state.home.canvasWall,
    multiCanvas: state.home.multiCanvas
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      vanillaDesign: bindActionCreators(vanillaDesignActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BottomBreadcrumb);
